import React from "react"
import { PosicaoClientesContextProvider } from "./context/PosicaoClientesContextProvider"
import { PosicaoClientes } from "./PosicaoClientes"

export function Index() {
    return (
        <PosicaoClientesContextProvider>
            <PosicaoClientes />
        </PosicaoClientesContextProvider>
    )
}
